(function ($) {
  $.fn.autoexpand = function autoexpand() {
    this.each(function () {
      const $el = $(this);

      function calculateLineHeight() {
          const savedValue = this.value;
          this.value = ''; // content temporarily removed to check base height
          this.baseScrollHeight = this.scrollHeight;
          this.value = savedValue;

          if (this.currentStyle) {
            this.lineHeight = parseFloat(this.currentStyle['line-height']);
          } else if (window.getComputedStyle) {
            this.lineHeight = parseFloat(document.defaultView.getComputedStyle(this, null).getPropertyValue('line-height'));
          } else {
            this.lineHeight = 22;
          }
      }

      function recalculateRows() {
        const minRows = this.getAttribute('data-min-rows') | 0;
        const maxRows = this.getAttribute('data-max-rows') | null;

        this.rows = minRows; // rows temporarily set to min
        const rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / this.lineHeight);
        const newRows = minRows + (isNaN(rows) ? 0 : rows);

        if (maxRows && newRows > maxRows) {
          this.rows = maxRows;
        } else {
          this.rows = newRows;
        }
      }

      calculateLineHeight.call(this);

      if (this.value) {
        recalculateRows.call(this);
      }

      $el.on('input', recalculateRows);
    });

    return this;
  };
}(jQuery));
